/**
 * aswbe checkin eapi
 * チェックイン業務で利用するAPIを提供する
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PostJourneysGetJourneyResponseDataServices } from './postJourneysGetJourneyResponseDataServices';
import { PostJourneysGetJourneyResponseDataFlightsInner } from './postJourneysGetJourneyResponseDataFlightsInner';
import { PostJourneysGetJourneyResponseDataSeatmapEligibility } from './postJourneysGetJourneyResponseDataSeatmapEligibility';
import { PostJourneysGetJourneyResponseDataTravelersSummary } from './postJourneysGetJourneyResponseDataTravelersSummary';
import { PostJourneysGetJourneyResponseDataTravelersInner } from './postJourneysGetJourneyResponseDataTravelersInner';

/**
 * journey情報
 */
export interface PostJourneysGetJourneyResponseData {
  /**
   * セグメント情報のリスト
   */
  flights: Array<PostJourneysGetJourneyResponseDataFlightsInner>;
  /**
   * 搭乗者情報のリスト
   */
  travelers: Array<PostJourneysGetJourneyResponseDataTravelersInner>;
  /**
   * セグメント・搭乗者ごとの情報
   */
  journeyElements: object;
  services?: PostJourneysGetJourneyResponseDataServices;
  /**
   * 手荷物預け入れ状況
   */
  baggages?: object;
  /**
   * 連絡先情報
   */
  contacts?: object;
  /**
   * 搭乗券発行機能利用可<br> 以下の条件すべてに合致する場合にtrue    |No|条件|   |---:|:---|   |1|Suffix便がjourney内に存在しない|   |2|チェックイン対象セグメント内に搭乗券発行可のセグメントが存在する|
   */
  isBoardingPassIssuanceEligibleToForward: boolean;
  /**
   * セグメント毎の発行可能搭乗券種別情報
   */
  eligibleBoardingPassType: object;
  seatmapEligibility?: PostJourneysGetJourneyResponseDataSeatmapEligibility;
  /**
   * シートマップスキップ可否<br> 搭乗者に席なし幼児(INF)を含まないまたは、直営PNRの場合、true
   */
  seatmapSkippable?: boolean;
  /**
   * iApi対象国の発着便あり<br> 設定ファイルに定義したiApi対象国の発着便が存在する場合にtrue
   */
  hasFlightToFromIapiTargetCountry: boolean;
  /**
   * すべてのjourneyElementのチェックインステータスを判定した結果<br> checkedIn: すべてチェックイン済みまたはスタンバイチェックイン済み<br> partial: チェックイン済みまたはスタンバイチェックイン済みと、未チェックインまたはチェックイン失敗が混在<br> notCheckedIn: すべて未チェックインまたはチェックイン失敗
   */
  checkInStatusSummary: PostJourneysGetJourneyResponseData.CheckInStatusSummaryEnum;
  /**
   * NHグループ運航便が複数存在する<br> 運航キャリアコードが\"NH\"、\"NQ\"、\"EH\"のセグメントが2件以上存在する場合にtrue
   */
  hasMultipleNhOperatingFlights: boolean;
  /**
   * Redress NumberおよびKnown Traveler Numberの対象となる国発着のセグメントが存在する<br> アメリカ、カナダまたはメキシコのいずれか発着のセグメントが存在する場合にtrue
   */
  hasSecureFlightProgramFlight: boolean;
  /**
   * アメリカ着のセグメントが存在する<br> アメリカ着のセグメントが存在する場合にtrue
   */
  hasFlightToUs: boolean;
  /**
   * カナダ着のセグメントが存在する<br> カナダ着のセグメントが存在する場合にtrue
   */
  hasFlightToCanada: boolean;
  travelersSummary: PostJourneysGetJourneyResponseDataTravelersSummary;
  /**
   * グループPNRである<br> グループPNRである場合にtrue
   */
  isGroupBooking: boolean;
  /**
   * 搭乗者情報変更操作が可能である<br> 1便目の受付ステータスがopenedである場合にtrue
   */
  isUpdateTravelersEligible: boolean;
  /**
   * サービス申込操作が可能である<br> 以下の条件のいずれかに合致する場合にtrue  |No|条件| |---:|:---| |1|1便目の受付ステータスがopenedである| |2|2便目以降かつ受付ステータスがopenedである、または直前の便が未出発であるセグメントが存在する|
   */
  isServiceApplicationEligible: boolean;
  /**
   * 1便目に未チェックイン、かつチェックイン不可の搭乗者が存在する<br> 以下の全ての条件に合致する搭乗者が存在する場合にtrue  |No|条件| |---:|:---| |1|1便目のセグメントに対する搭乗者のチェックインステータスが未チェックインである| |2|搭乗者の1便目のチェックイン可否判定結果がチェックイン不可である|
   */
  hasTravelerUnableToCheckInForFirstFlight: boolean;
  /**
   * 空席待ち機能利用可<br> 空席待ち詳細情報取得要否がtrueの場合にのみ返却する<br> 以下のすべての条件に合致する場合にtrue    |No|条件|   |---:|:---|   |1|搭乗者メールアドレス（SK MAIL）未登録の搭乗者が存在しない|   |2|すべての搭乗者が未搭乗である未出発セグメントの1便目（以下、ORI便とする）の出発日当日0時を過ぎている|
   */
  isStandbyEntryEligibleToForward?: boolean;
  /**
   * 空席待ち可<br> 空席待ち詳細情報取得要否がtrueの場合にのみ返却する<br> 判定条件はstandbyEntryIneligibleType項目を参照
   */
  isStandbyEntryEligible?: boolean;
  /**
   * 空席待ち不可区分<br> 空席待ち詳細情報取得要否がtrue、かつ空席待ち不可の場合にのみ返却する<br> 以下の条件を項番の順に判定し、いずれかの条件に合致した時点で空席待ち不可としてその空席待ち不可区分を返却する    |No|条件|空席待ち不可区分の値|備考|   |---:|:---|:---|:---|   |1|グループPNRである|unhandleable||   |2|journey内に3便以上のセグメントが存在する|unhandleable||   |3|ORI便の前に未搭乗かつ未出発のセグメントが存在する搭乗者が存在する|unhandleable||   |4|ORI便のOnload StatusがFinalizedである|unhandleable||   |5|journey内にASWDBで管理する提携航空会社以外とのコードシェア便が存在する|unhandleable||   |6|journey内にAltea移行前（able）空港発着のセグメントが存在する|unhandleable||   |7|NHプレートチケット(205券)以外で発券している|unhandleable||   |8|同行者追加されている|handleableInAirport||   |9|手荷物預け入れ済みの搭乗者が存在する|handleableInAirport||   |10|ORI便に対して搭乗者のキャビンクラスが混在している|handleableInAirport||   |11|Change Journey不可としてASWDBに保持しているSSRが存在する|handleableInAirport||   |12|ORI便に対して搭乗者がHigh Priority制限を保持し、かつ以下のいずれかに該当する<br>1. Acceptance comment(ACC)が登録されている<br>2. Next comment(NXT)が登録されている|handleableInAirport||   |13|ORI便の前に未搭乗かつ出発済みのセグメントが存在する搭乗者が存在する|handleableInAirport||   |14|PNR内に国際線が存在する|handleableInAirport||   |15|PNR responsible officeがNH3である|handleableInAirport||   |16|同一出発日、同一区間、同一便名で、キャビンクラスが異なるORI便とHL便を保持している搭乗者が存在する|handleableByUserForUpgradeStandby||   |17|ORI便がHow about this flightケースで提案された便である、かつ確定済みでない|handleableByUserForTransferOption|ASWDBの振替オプション情報からHow about this flightケースを判断する|
   */
  standbyEntryIneligibleType?: PostJourneysGetJourneyResponseData.StandbyEntryIneligibleTypeEnum;
  /**
   * 予約詳細画面への遷移が可能である<br> 以下の条件のいずれかに合致する場合にtrue  |No|条件| |---:|:---| |1|1便目の受付ステータスがopenedである| |2|2便目以降かつ受付ステータスがopenedである、または直前の便が未出発であるセグメントが存在する|
   */
  isReservationDisplayEligible: boolean;
}
export namespace PostJourneysGetJourneyResponseData {
  export type CheckInStatusSummaryEnum = 'checkedIn' | 'partial' | 'notCheckedIn';
  export const CheckInStatusSummaryEnum = {
    CheckedIn: 'checkedIn' as CheckInStatusSummaryEnum,
    Partial: 'partial' as CheckInStatusSummaryEnum,
    NotCheckedIn: 'notCheckedIn' as CheckInStatusSummaryEnum,
  };
  export type StandbyEntryIneligibleTypeEnum =
    | 'unhandleable'
    | 'handleableInAirport'
    | 'handleableByUserForUpgradeStandby'
    | 'handleableByUserForTransferOption';
  export const StandbyEntryIneligibleTypeEnum = {
    Unhandleable: 'unhandleable' as StandbyEntryIneligibleTypeEnum,
    HandleableInAirport: 'handleableInAirport' as StandbyEntryIneligibleTypeEnum,
    HandleableByUserForUpgradeStandby: 'handleableByUserForUpgradeStandby' as StandbyEntryIneligibleTypeEnum,
    HandleableByUserForTransferOption: 'handleableByUserForTransferOption' as StandbyEntryIneligibleTypeEnum,
  };
}
